import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Services API
export const getServices = async () => {
  try {
    const response = await axios.get(`${API}/services`);
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    return [];
  }
};

// Products API
export const getProducts = async () => {
  try {
    const response = await axios.get(`${API}/products`);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    return [];
  }
};

// Promotions API
export const getPromotions = async () => {
  try {
    const response = await axios.get(`${API}/promotions`);
    return response.data;
  } catch (error) {
    console.error('Error fetching promotions:', error);
    return [];
  }
};

// Bookings API
export const createBooking = async (bookingData) => {
  try {
    const response = await axios.post(`${API}/bookings`, bookingData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error creating booking:', error);
    return { success: false, error: error.response?.data?.detail || 'Erro ao criar marcação' };
  }
};

export const getBookings = async () => {
  try {
    const response = await axios.get(`${API}/bookings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching bookings:', error);
    return [];
  }
};

// Group services by category
export const groupServicesByCategory = (services) => {
  const grouped = services.reduce((acc, service) => {
    const category = service.category;
    if (!acc[category]) {
      acc[category] = {
        category,
        items: []
      };
    }
    acc[category].items.push(service);
    return acc;
  }, {});
  
  return Object.values(grouped);
};

// Group products by category
export const groupProductsByCategory = (products) => {
  const grouped = products.reduce((acc, product) => {
    const category = product.category;
    if (!acc[category]) {
      acc[category] = {
        category,
        products: []
      };
    }
    acc[category].products.push(product);
    return acc;
  }, {});
  
  return Object.values(grouped);
};
